import React from "react";
import { Grid, Button, makeStyles, Typography } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  headerText: {
    fontSize: 25,
    marginTop: 24,
    marginBottom: 16,
    color: "#111",
    textAlign: "center",
    lineHeight: "24px",
    fontWeight: "bold",
    fontFamily: theme.typography.fontFamily,
    textTransform:'none'
  },
  subHeader: {
    fontSize: 16,
    textAlign: "center",
    margin: "2% 2%",
    lineHeight: "28px",
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.secondary,
    fontWeight: 400,
    maxWidth:'600px'
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: 20,
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  image: {
    width: 250,
    height: 200,
    marginTop: "10%",
  },
}));

const ApprovalDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const handleNext = async () => {
    navigate("/journey/CongraculationDetails");
  }
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader label="Approval" button1={"Next"} button1click={handleNext}/>
      </Grid>
      <Grid item xs={12} className={classes.mainContainer}>
        <img
          className={classes.image}
          src="/images/approval.png"
          alt="Approval"
        />
        <Typography variant="h6" className={classes.headerText}>
          Application submitted for approval
        </Typography>
        <Typography className={classes.subHeader}>
          {`This should take only a few minutes. We will notify you (via SMS) once
          we have verified your profile. You can click the "Refresh" button to
          check again.`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ApprovalDetails;
